import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a45740ac&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45740ac')) {
      api.createRecord('a45740ac', component.options)
    } else {
      api.reload('a45740ac', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a45740ac&", function () {
      api.rerender('a45740ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mirWXCsfmgie/JS/offershelp.vue"
export default component.exports